module.exports = __webpack_public_path__ + "img/notifications.7eee0cd4.png";